import { put, takeEvery } from 'redux-saga/effects'
import { GET_MEMBERVALIDATION_INFO_LOADING, MEMBERVALIDATION_DATA_SUCCESS, MEMBERVALIDATION_DATA_ERROR } from "../actions/actionMemberValidation";
import { apiMemberValidation } from 'api';

async function fetchAsync(func, param) {
  const response = await func(param);

  if (response.ok) {
    return await response.json();
  }
  if (response.status == 400) {
    let error = await response.json();
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + "\"}]}")
  }
  else {
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to apply membership, response status: " + "\"}]}")
  }
}

function* fetchMemberValidationData(action) {
  try {
    const data = yield fetchAsync(apiMemberValidation, action.payload)
    yield put({ type: MEMBERVALIDATION_DATA_SUCCESS, payload: data });
  } catch (e) {
    yield put({ type: MEMBERVALIDATION_DATA_ERROR, error: e.Errors[0].ErrorMessage });
  }
}

export const sagaMemberValidation = [
  takeEvery(GET_MEMBERVALIDATION_INFO_LOADING, fetchMemberValidationData)
];
